import { Injectable } from '@angular/core';
import { GTManagerItem } from './google-tag-manager-item.model';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {

  constructor() { }

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
  };

  public pushOnDataLayer(item: GTManagerItem): void {

    const dataLayer = this.getDataLayer();
    dataLayer.push(item);
  }

  private getDataLayer(): any[] {
    const window = this.browserGlobals.windowRef();
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }
}
